'use strict';

module.exports = {
  singleProduct: 'SINGLE_PRODUCT',
  productsList: 'PRODUCTS_LIST'
};